let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bX4za")).then(() => parcelRequire('4s0QM'));